import React, { useEffect, useState } from "react";
import { Row, Card } from "react-bootstrap";
import StorageManagement from "./StorageManagement";
import StorageManagmentChart from "./StorageManagmentChart";
import StorageManagementMonthly from "./StorageManagementMonthly";
import {
  GET_OVERALL_STORAGE,
  GET_STORAGE_API,
  GET_STORAGE_MINUTE_API,
} from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";
import { toast } from "react-toastify";
import EmployeeSelect from "../../Components/Common/EmployeeSelect";
import { Button, CardBody, FormGroup, Label } from "reactstrap";
import { formatDate } from "../../Components/Common/FormDateTime";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Loader from "../../Components/Common/Loader";
import StorageCard from "./StorageCard";
import MonthlyDatePicker from "../../Components/Common/MonthlyDatePicker";
import dayjs from "dayjs";
import EmployeeSelectAll from "../../Components/Common/EmployeeSelectAll";
import CalculateRemainingDays from "../../Components/Common/CalculateRemainingDays";
import { useProfileData } from "../../Components/Hooks/UserHooks";
import { useNavigate } from "react-router-dom";
import SubExpired from "../../Components/Common/subExpired";
const api = new APIClient();

const Storage = () => {
  const pageTitle = "Storage Management";
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const viewReportPermission = permissionType?.includes("VIEW_REPORT");
  const loginType = JSON.parse(localStorage.getItem("logintype"));
  const [teamIndu, setTeamIndu] = useState([]);
  const [storageData, setStorageData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
  const [EmployeeData, setEmployeeData] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [flag, setFlag] = useState("");
  const [EmployeeDefaultWithoutTeam, setEmployeeDefaultWithoutTeam] = useState(
    []
  );
  const [totalRows, setTotalRows] = useState(0);
  const [filterData, setFilterData] = useState([]);
  const [error, setError] = useState("");
  const [selectedFromMonth, setSelectedFromMonth] = useState(dayjs());
  const [selectedToMonth, setSelectedToMonth] = useState(dayjs());
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
  const navigate = useNavigate();
  const { profileData } = useProfileData();
  const remainingDays = CalculateRemainingDays();

  const clearData = () => {
    setStorageData([]);
    setFilterData([]);
    setTotalRows(0);
  };

  const checkAllDataLoaded = () => {
    if (storage && storageData.length >= 0 && filterData.length >= 0) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      selectedEmployeeOptions?.length > 0 &&
      selectedFromMonth &&
      selectedToMonth
    ) {
      const updatedIds = selectedEmployeeOptions.map((userid) => userid?.id);
       const data = fetchStorageData(updatedIds, []);
      const data2 = fetchNewStorageData(updatedIds, []);
      if(data && data2)
      {
        setIsLoading(true);
      }
    }
  }, [currentPage, perPage]);

  useEffect(() => {
    setSelectedEmployeeOptions(EmployeeDefaultWithoutTeam);
  }, [EmployeeDefaultWithoutTeam]);

  const [storage, setStorage] = useState(null);

  useEffect(() => {
    const fetchStorageData = async () => {
      try {
        const response = await api.get(GET_OVERALL_STORAGE);
        setStorage(response.data);
        checkAllDataLoaded();
      } catch (error) {
        console.error("Error fetching storage data:", error);
      }
    };

    fetchStorageData();
  }, []);

  const fetchStorageData = async (updatedIds = [], defaultId = []) => {
    try {
      const employeeIds = defaultId.length > 0 ? defaultId : updatedIds;

      if (employeeIds.length === 0) {
        clearData();
        checkAllDataLoaded();
        return;
      }
      const startMonth = formatMonth(selectedFromMonth).slice(0, 2);
      const startYear = formatMonth(selectedFromMonth).slice(3, 7);
      const endMonth = formatMonth(selectedToMonth).slice(0, 2);
      const endYear = formatMonth(selectedToMonth).slice(3, 7);

      const data = {
        startMonth: startMonth,
        startYear: startYear,
        endMonth: endMonth,
        endYear: endYear,
        employeeIds: employeeIds,
      };

      const response = await api.create(
        `${GET_STORAGE_MINUTE_API}?pg=${1}&lm=${10}`,
        data
      );

      if (response?.success) {
        setStorageData(response?.data);
        checkAllDataLoaded();
      } else {
        toast.error("Failed to fetch storage data!");
        clearData();
        checkAllDataLoaded();
      }
    } catch (error) {
      clearData();
    } finally {
      checkAllDataLoaded();
    }
  };

  const fetchNewStorageData = async (updatedIds = [], defaultId = []) => {
    try {
      const employeeIds = defaultId.length > 0 ? defaultId : updatedIds;
      if (employeeIds.length === 0) {
        clearData();
        checkAllDataLoaded();
        return;
      }
      // setFilterData([])
      const startMonth = formatMonth(selectedFromMonth).slice(0, 2);
      const startYear = formatMonth(selectedFromMonth).slice(3, 7);
      const endMonth = formatMonth(selectedToMonth).slice(0, 2);
      const endYear = formatMonth(selectedToMonth).slice(3, 7);
      const data = {
        startMonth: startMonth,
        startYear: startYear,
        endMonth: endMonth,
        endYear: endYear,
        employeeIds: employeeIds,
      };

      const response = await api.create(
        `${GET_STORAGE_API}?pg=${currentPage}&lm=${perPage}`,
        data
      );
      if (response?.success && response?.data) {
        const { monthlyData } = response.data;
        const formattedData = monthlyData?.map((item) => {
          const employee = item?.employeeDetails[0] || {};
          return {
            id: item?.employeeId,
            employeeName: employee.fullName || "Unknown",
            profileImageUrl: null,
            teamName: employee.team?.join(", ") || "-",
            usageSpace: item.employeeStorage || 0,
            numberOfFiles: item.numberOfFiles || 0,
          };
        });
        setFilterData(formattedData);
        setTotalRows(response.data.totalCount);
        checkAllDataLoaded();
      } else {
        clearData();
        checkAllDataLoaded();
      }
    } catch (error) {
      console.error("Error fetching storage data:", error);
      clearData();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const defaultId =
      EmployeeDefaultWithoutTeam?.map((option) => option?.id) || [];
    if (EmployeeData?.length > 0) {
      fetchStorageData([], defaultId);
      fetchNewStorageData([], defaultId);
    } else {
      clearData();
      checkAllDataLoaded();
    }
  }, [EmployeeData]);

  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("month");
  };

  const disablePastDatesForToDate = (current) => {
    if (!selectedFromMonth) return current && current > dayjs().endOf("month");
    const maxToMonth = dayjs(selectedFromMonth).add(3, "month").endOf("month");
    return (
      current &&
      (current < dayjs(selectedFromMonth).startOf("month") ||
        current > maxToMonth ||
        current > dayjs().endOf("month"))
    );
  };

  const handleFromDateChange = (date) => {
    setSelectedFromMonth(date);

    if (date) {
      const maxToDate = dayjs(date).add(3, "month"); // Maximum To Month (3 months ahead)
      const currentMonth = dayjs(); // Current month
      const newToMonth = maxToDate.isAfter(currentMonth)
        ? currentMonth
        : maxToDate;

      if (
        !selectedToMonth ||
        dayjs(date).isAfter(selectedToMonth) ||
        dayjs(selectedToMonth).isAfter(maxToDate)
      ) {
        setSelectedToMonth(newToMonth);
      }
    }
  };

  const handleToDateChange = (date) => {
    if (selectedFromMonth && dayjs(date).isBefore(selectedFromMonth)) {
      return;
    }
    setSelectedToMonth(date);
  };

  const formatMonth = (date) => {
    return date ? date.format("MM,YYYY") : "";
  };

  const handleSubmit = () => {
    const updatedIds = selectedEmployeeOptions?.map((userid) => userid?.id);
    if (selectedEmployeeOptions?.length === 0) {
      setError("You must select at least one");
    } else {
      if (updatedIds.length === 0) {
        clearData();
      } else {
       const dataFetchStorage=  fetchStorageData(updatedIds, "");
       const dataNewFetchStorage= fetchNewStorageData(updatedIds, "");
       if(dataFetchStorage && dataNewFetchStorage)
       {
        setIsLoading(true);
       }
      }
      setFlag(true);
      setCurrentPage(1);
      setPerPage(10);
      setError("");
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const resetInputHistory = () => {
    setSelectedToMonth("");
    setSelectedFromMonth("");
    setSelectedEmployeeOptions([]);

    clearData();
  };

  const totalStorage = storage?.totalStorage
    ? parseFloat(storage.totalStorage.replace(" GB", ""))
    : 0;
  const usedStorage = storage?.usedStorage
    ? parseFloat(storage.usedStorage.replace(" GB", ""))
    : 0;
  const remainStorage = storage?.remainStorage
    ? parseFloat(storage.remainStorage.replace(" GB", ""))
    : 0;

  const percentUsed = storage?.usedStoragePercent
    ? storage?.usedStoragePercent
    : 0;

  const percentRemaining = storage?.remainStoragePercent
    ? storage?.remainStoragePercent
    : 0;

    const handleClose = () => {
      setIsExpiredModalOpen(false);
      navigate("/planPackage");
    };
    
  return (
    <React.Fragment>  {(remainingDays === 0 && isExpiredModalOpen) && <SubExpired onClose={handleClose} profileData={profileData?.selectedPlanDetails?.planName} remainingDays={remainingDays} />} 
    <div className="page-content sn-employee-report-page-main">
      <div className="container-fluid">
        <BreadCrumb title={pageTitle} />

        <div className="row">
          <div className="col-md-4 col-lg-4">
            <StorageCard
              title="Total Storage"
              value={storage?.totalStorage}
              percent={100}
              tooltipText="Total available storage capacity."
              iconClass="las la-database"
              bgColor="#265c2e1f"
              iconColor="#265c2e"
              percentLabel="Total"
            />
          </div>
          <div className="col-md-4 col-lg-4">
            <StorageCard
              title="Used Storage"
              percent={percentUsed}
              value={storage?.usedStorage}
              tooltipText="Storage capacity currently in use."
              iconClass="las la-chart-bar"
              bgColor="#f0ad4e1f"
              iconColor="#f0ad4e"
              percentLabel="Utilized"
            />
          </div>
          <div className="col-md-4 col-lg-4">
            <StorageCard
              title="Remaining Storage"
              value={storage?.remainStorage}
              percent={percentRemaining}
              tooltipText="Storage capacity still available."
              iconClass="las la-check-circle"
              bgColor="#5cb85c1f"
              iconColor="#5cb85c"
              percentLabel="Available"
            />
          </div>
        </div>

        <Row className="sn-header-select-employess-home sn-team-managment-tble sn-top-inputs-heading">
          <div className="row">
            {((viewReportPermission && loginType === "employee") ||
              loginType === "organization") && (
              <div className="col-md-4 col-sm-12 sn-select-employees-box ">
                <EmployeeSelectAll
                  setTeamIndu={setTeamIndu}
                  teamIndu={teamIndu}
                  setEmployeeDefaultWithoutTeam={setEmployeeDefaultWithoutTeam}
                  EmployeeDefaultWithoutTeam={EmployeeDefaultWithoutTeam}
                  setEmployeeData={setEmployeeData}
                  EmployeeDefault={
                    teamIndu.length === 0
                      ? EmployeeDefaultWithoutTeam
                      : EmployeeData
                  }
                  setEmployeeDefault={setEmployeeData}
                  selectedEmployeeOptions={selectedEmployeeOptions}
                  setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                  labelContent="Select Employee"
                  error={error}
                  setError={setError}
                />
              </div>
            )}

            <div className="col-md-3 col-sm-12 ">
              <MonthlyDatePicker
                label="From Month"
                pickerType="month"
                onChange={handleFromDateChange}
                disabledDate={disableFutureDates}
                value={selectedFromMonth}
              />
            </div>
            <div className="col-md-3 col-sm-12 ">
              <MonthlyDatePicker
                label="To Month"
                pickerType="month"
                onChange={handleToDateChange}
                disabledDate={disablePastDatesForToDate}
                value={selectedToMonth}
              />
            </div>

            <div className="col-md-2 col-sm-12">
              <FormGroup className="mt-2 mb-4">
                <Label for="exampleSelect"></Label>
                <div id="exampleSelect" className="sn-call-apply-btn-reset">
                  <Button
                    id="exampleSelect"
                    type="submit"
                    color="danger"
                    className=""
                    onClick={handleSubmit}
                    disabled={isLoading}
                  >
                    Apply
                  </Button>
                  <Button
                    className=""
                    style={{ marginLeft: "10px" }}
                    id="exampleSelect"
                    outline
                    color="danger"
                    onClick={resetInputHistory}
                    disabled={isLoading}
                  >
                    Reset
                  </Button>
                </div>
              </FormGroup>
            </div>
          </div>
        </Row>

        <Row>
          <div className="col-md-12 col-sm-12 mb-4">
            <Card
              className="sn-storage-managment-card-chart shadow-lg p-3 rounded"
              style={{ height: "auto", minHeight: "auto" }}
            >
              <StorageManagementMonthly
                data={storageData}
                isLoading={isLoading}
                selectedEmployeeOptions={selectedEmployeeOptions}
               
              />
            </Card>
          </div>
        </Row>
        {isLoading ? (
          <div className="loader-overlay">
            <Loader />
          </div>
        ) : (
          ""
        )}
        <StorageManagement
          filterData={filterData}
          isLoading={isLoading}
          setCurrentPage={setCurrentPage}
          setPerPage={setPerPage}
          currentPage={currentPage}
          perPage={perPage}
          totalRows={totalRows}
          handlePageChange={handlePageChange}
          handlePerRowsChange ={handlePerRowsChange}
          selectedFromMonth={selectedFromMonth}
          selectedToMonth={selectedToMonth}
        />
      </div>
    </div>
    </React.Fragment>
  );
};

export default Storage;
